import apiClient from "./axios"

export const getAccountDayCloses = async (params = {}) => {
  const { data } = await apiClient.get("/account-day-closes", { params })
  return data
}

export const getAccountDayClose = async id => {
  const { data } = await apiClient.get(`/account-day-closes/${id}`)
  return data
}

export const closeAccountDay = async payload => {
  const { data } = await apiClient.post("/account-day-closes", payload)
  return data
}

export const reopenAccountDayClose = async ({ id, reason }) => {
  const { data } = await apiClient.post(`/account-day-closes/${id}/reopen`, { reason })
  return data
}
